/**
 * The API reads an event's Approval as one FLAT object (`ApprovalUpdate` in
 * pymble-apis) and writes it into the nested stored shape. The read shape the
 * editor holds is nested, so a nested Approval sent back as-is is ignored and
 * the server writes null over Checks, RSVP and Urls. Add the flat write keys
 * alongside the nested ones; the nested copy is harmless and keeps the draft
 * unchanged.
 */
type Json = Record<string, unknown>;

const isRecord = (v: unknown): v is Json =>
	typeof v === "object" && v !== null && !Array.isArray(v);

export function withFlatApproval(approval: unknown): unknown {
	if (!isRecord(approval)) return approval;
	const checks = isRecord(approval.Checks) ? approval.Checks : {};
	const rsvp = isRecord(approval.RSVP) ? approval.RSVP : {};
	const urls = isRecord(approval.Urls) ? approval.Urls : {};
	const reminders = Array.isArray(rsvp.ReminderDays) ? rsvp.ReminderDays : [];
	return {
		...approval,
		MedicalCheck: checks.Medical ?? null,
		EmergencyContact: checks.EmergencyContact ?? null,
		DietaryCheck: checks.Dietary === true,
		PermissionLockDays: rsvp.LockDays ?? approval.PermissionLockDays ?? null,
		FirstReminderDays: reminders[0] ?? null,
		SecondReminderDays: reminders[1] ?? null,
		FormUrl: urls.Event ?? null,
		MoreInfoUrl: urls.MoreInfo ?? null,
	};
}
